import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  KeyboardAvoidingView,
  TouchableOpacity,
  View,
  Animated,
  PanResponder,
  useWindowDimensions,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
  Dimensions,
  Pressable
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import styles from './styles';
import gs from '../../styles/globalStyles';
import { SCREEN_SIZE } from '@voltmoney/types';
import {
  getScreenType,
} from '@voltmoney/platform';
import { useAppSelector } from '@app/store/hooks';
import {useDarkMode} from '@app/utils';
import { X } from '@sharedComponents/Icons';

const SUPPORTED_ORIENTATIONS = [
  'portrait',
  'portrait-upside-down',
  'landscape',
  'landscape-left',
  'landscape-right',
];

const windowHeight = Dimensions.get('window').height;
const windowWidth = Dimensions.get('window').width;
const screenType = getScreenType(windowWidth);

  

const Wrapper = ({  children }) => {
  return   (
    <View style={[gs.flexOne, gs.justifyCenter, gs.alignItemsCenter]}>
      {children}
    </View>
  ) 
};

const BottomSheetContainer = ({
  children,
  isVisible,
  close,
  onClose,
  dragComponent,
  closeOnBackdropPress = true,
  containerStyle,
  containsTextInput = false,
  borderTopRightRadius,
  borderTopLeftRadius,
  showCloseIcon = true
}) => {
  const [isVisibleInternal, setIsVisibleInternal] = useState(false);
  const { height } = useWindowDimensions();
  const pan = useRef(new Animated.Value(height)).current;  // Initial position for translation
  const { top, bottom } = useSafeAreaInsets(); // Safe area insets
  const {showVoltDefaultHeader,platform} = useAppSelector((state) => state.platformParams);
  const isOpeninMobile = Platform.OS === 'web' ? window.innerWidth <= 768 : false; // Common threshold for mobile devices
  const isDarkMode = useDarkMode();
  const viewHeightSmallToMedium = (platform) => {
    if(isOpeninMobile) {
    return windowHeight;
  }
    switch (true) {
      case platform==='SDK_INVESTWELL':
        return windowHeight - 28;
      case showVoltDefaultHeader:
        return windowHeight - 60;
      default:
        return windowHeight;
    }
  };
  
  const viewHeightMediumToLarge = () => {
    switch (true) {
      case showVoltDefaultHeader:
        return windowHeight - 114;
      default:
        return windowHeight;
    }
  };
  const bottomSheetheight =
  screenType === SCREEN_SIZE.X_SMALL || screenType === SCREEN_SIZE.SMALL
    ? viewHeightSmallToMedium()
    : viewHeightMediumToLarge();

  const createPanResponder = () => {
    return PanResponder.create({
      onStartShouldSetPanResponder: () => true,
      onPanResponderMove: (e, gestureState) => {
        if (gestureState.dy > 0) {
          Animated.event([null, { dy: pan }], { useNativeDriver: true })(e, gestureState);
        }
      },
      onPanResponderRelease: (e, gestureState) => {
        if (gestureState.dy > 80) {
          setModalVisible(false, true);
        } else {
          Animated.spring(pan, {
            toValue: 0,
            useNativeDriver: true,  // Use native driver for performance
          }).start();
        }
      },
    });
  };

  const panResponder = useRef(createPanResponder()).current;

  useEffect(() => {
    if (isVisibleInternal === isVisible) {
      return;
    }
    setModalVisible(isVisible);
  }, [isVisible]);

  useEffect(() => {
    if (Platform.OS === 'web') {
      if (isVisible) {
        document.body.style.overflow = "hidden"; // Prevent scrolling
      } else {
        document.body.style.overflow = "auto"; // Re-enable scrolling
      }
    }

    // Cleanup on unmount
    return () => {
      if(Platform.OS === 'web'){
        document.body.style.overflow = "auto";
      }
    };
  }, [isVisible]);

  const setModalVisible = (visible, fromDrag = false) => {
    if (visible) {
      setIsVisibleInternal(true);
      Animated.timing(pan, {
        useNativeDriver: true,  // Use native driver for performance
        toValue: 0,  // Initial position when modal is visible
        duration: containsTextInput ? (Platform.select({
          ios : 0,
          android : 250,
          web : 500
        })) : Platform.OS === 'web' ? 550 : 300,
      }).start();
    } else {
      Animated.timing(pan, {
        useNativeDriver: true,
        toValue: height,  // Slide out of view
        duration:(containsTextInput && Platform.OS === 'android') ?  250 : Platform.OS === 'web' ? 550 : 300,
      }).start(() => {
        setIsVisibleInternal(false);
        onClose && onClose();
        fromDrag && close();
      });
    }
  };
  return (
    <Modal
      transparent
      animationType="none"
      visible={isVisibleInternal}
      supportedOrientations={SUPPORTED_ORIENTATIONS}
      onRequestClose={close}>
      <Wrapper containsTextInput={containsTextInput}>
        <KeyboardAvoidingView
          enabled={true}
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={[styles.wrapper, gs.setPaddingTop(top) ,{height:Platform.OS === 'web'? bottomSheetheight:windowHeight,marginBottom:bottomSheetheight===windowHeight?0: Platform.select({web : windowWidth>767 ? 30:0 , ios : 0 , android : 0}) }, isOpeninMobile && {top :0} ]}>
          <TouchableOpacity
            style={styles.mask}
            activeOpacity={1}
            onPress={closeOnBackdropPress ? close : () => {}}
          />
          <Animated.View
            style={[
              styles.container,
              gs.setPaddingBottom(bottom),
              containerStyle,
              gs.setBg(isDarkMode?'#0c1119':'#fff'),
              {
                transform: [{ translateY: pan }], // Apply translation based on pan value
                borderTopLeftRadius: borderTopLeftRadius,
                borderTopRightRadius: borderTopRightRadius,
              },
            ]}>
            {/* Disabling Drag as not needed*/}
            {/* <View {...panResponder.panHandlers}> */}
            <View style={{marginBottom : isOpeninMobile && containsTextInput ? 40 : 0}}>
            { showCloseIcon && 
            <Pressable onPress={close} style={styles.closeIcon}>
                <X size={20} />
              </Pressable>}
              {children}
            </View>
          </Animated.View>
        </KeyboardAvoidingView>
      </Wrapper>
    </Modal>
  );
};

export default BottomSheetContainer;
